module.exports = __webpack_public_path__ + "sn.c95adb975759cd776fb9.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/sn.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/sn.svg
// module chunks = styles